<script setup lang="ts">

import { usePlanetStore } from '@/stores/planetStore.ts'
import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'
import { defineProps } from 'vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import TagButton from '@/components/Elements/Buttons/TagButton.vue'

const planetStore = usePlanetStore()

/**
 * Props
 */
const props = defineProps({
  type: {
    type: String,
    required: true
  },
  amount: {
    type: Number,
    required: true
  },
  oreId: {
    type: Number,
    required: false
  }
});

/**
 * Functions
 */
const setTab = () => {
  planetStore.planetStatsTab = props.type;
  planetStore.planetStatsTabNoData = props.amount === 0;
}

</script>

<template>
  <TagButton
    :selected="planetStore.planetStatsTab === type"
    @click="setTab"
    class="!block w-full !mr-0 mb-1"
  >
    <div class="flex items-center justify-between w-full">
      <template v-if="type === 'primary_ore' || type === 'secondary_ore'">
        <GenericIcon :type="'ore' + oreId"/>
      </template>
      <template v-else>
        <GenericIcon :type="type"/>
      </template>
      <ColoredNumber :amount="amount" :allowZero="true" class="ps-4"></ColoredNumber>
    </div>
  </TagButton>
</template>

<style scoped lang="scss">
</style>